import React from "react";
import { FieldError, FieldErrorsImpl, Merge } from "react-hook-form";

export default function FormError({
  error,
}: {
  error: FieldError | Merge<FieldError, FieldErrorsImpl<any>> | undefined;
}): React.ReactElement {
  return (
    <>
      {error && (
        <div className="mt-2 text-sm leading-tight text-[#AB1B07]">
          {error.message?.toString()}
        </div>
      )}
    </>
  );
}
